// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"styles_tabsWrapper__1v7sO","tabsList":"styles_tabsList__3cKsn","tabItems":"styles_tabItems__1j1Ph","text":"styles_text__2InXI","activeTab":"styles_activeTab__Vlj39"};